import { Box, Button, Checkbox, Typography } from '@mui/joy';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';


export default function SelectionToolbar({
    selectMode, onEnter, onExit,
    count, totalSelectable, allChecked, onToggleAll,
    onDelete, deleting,
    enterLabel = 'Выбрать несколько',
    deleteLabel = 'Удалить выбранные',
}) {
    if (!selectMode) {
        return (
            <Button size="sm" variant="soft" color="neutral" onClick={onEnter}
                sx={{ fontWeight: 700, mb: 1.5,  }}>
                {enterLabel}
            </Button>
        );
    }
    return (
        <Box sx={{
            display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap',
            p: 1, mb: 1.5, borderRadius: 'var(--joy-radius-md)',
            bgcolor: 'var(--joy-palette-background-level2)',
            border: '1px solid var(--joy-palette-divider)',
        }}>
            <Checkbox size="sm" label="Выбрать всё"
                checked={allChecked && totalSelectable > 0}
                indeterminate={count > 0 && !allChecked}
                onChange={onToggleAll}
                sx={{ fontWeight: 700 }} />
            <Typography sx={{ fontSize: 12, color: 'var(--joy-palette-text-secondary)' }}>
                Выбрано: {count}
            </Typography>
            <Box sx={{ flex: 1 }} />
            <Button size="sm" variant="soft" color="danger"
                startDecorator={<DeleteRoundedIcon sx={{ fontSize: 16 }} />}
                disabled={count === 0} loading={deleting}
                onClick={onDelete} sx={{ fontWeight: 700 }}>
                {deleteLabel}{count > 0 ? ` (${count})` : ''}
            </Button>
            <Button size="sm" variant="soft" color="neutral" onClick={onExit}
                sx={{ fontWeight: 700 }}>
                Отмена
            </Button>
        </Box>
    );
}